import HttpService from "./HttpService";
import UtilsService from "./UtilsService";
import { ACCEPTED_BUSINESSES_TYPES, MAPS_API_KEY } from "../const";
const http = new HttpService();
const utilsService = new UtilsService();

export default class MapsService {
  /**
   * Get the details of a place by its google id
   * @param googleId id to look for in Google Places
   * @param returnIfNotCorrectType Either we should return the element even thouh it's not a place with a possible wifi (church, etc.)
   * @param allInfo false to get only name, address and type. True to get all infos we need for place details (photos)
   * @returns
   */
  getDetailsFromBusinessId = async (
    ownerId: string,
    googleId: string,
    returnIfNotCorrectType: boolean
  ) => {
    console.log("get details", ownerId, googleId);
    const googlePlaceInfo = await http.fetch(
      "GET",
      `api/place/web/placeGoogleInfo/owner/${ownerId}/place/${googleId}`
    );

    console.log("googlePlaceInfo", googlePlaceInfo);

    let isTypePresent = false;

    // loop on result place to see if it belongs to the place that have wifi
    googlePlaceInfo.data.result.types.forEach((googlePlaceType: any) => {
      if (ACCEPTED_BUSINESSES_TYPES.includes(googlePlaceType)) {
        isTypePresent = true;
      }
    });

    console.log("isTypePresent", isTypePresent);

    // // if we shouldn't return it if not right type AND is indeed not right type
    if (!returnIfNotCorrectType && !isTypePresent) {
      console.log("ko");
      return { display: false };
    } else {
      console.log("ok");
      return googlePlaceInfo.data.result;
    }
  };

  /**
   * Search a place with a given name
   * @param searchText
   */
  getPlaceFromSearchText = async (
    ownerId: string,
    text: string,
    coords: any
  ) => {
    text = utilsService.sanitizeString(text);
    text = text.replaceAll(" ", "+");
    text = text + "+bar+cafe+restaurant";

    const geoSearchResult = await http.fetch(
      "GET",
      `api/place/web/searchPlaceByName/owner/${ownerId}/text/${text}`,
      {}
    );
    // const parsedGeoSearchResult = JSON.parse(geoSearchResult);
    console.log("geoSearchResult", geoSearchResult);
    if (geoSearchResult.success) {
      return geoSearchResult.data.results[0];
    } else {
      return [];
    }
  };
}
